var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35.593,
  height: 35.502,
  viewBox: "0 0 35.593 35.502"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-562.703 -208.71)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.213,33.426h-24a.531.531,0,0,1-.53-.53V13.169a.53.53,0,1,1,1.061,0v19.2H28.683v-19.2a.53.53,0,1,1,1.061,0V32.9A.53.53,0,0,1,29.213,33.426Z",
  transform: "translate(563.285 210.536)",
  stroke: "currentColor",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.47,17.089a.532.532,0,0,1-.365-.144L17.5,1.26.895,16.943a.53.53,0,0,1-.729-.771L17.134.145a.531.531,0,0,1,.73,0L34.834,16.172a.531.531,0,0,1-.365.916Z",
  transform: "translate(563 209)",
  stroke: "currentColor",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.081,6.909V4.567h5.043v7.062Z",
  transform: "translate(564.399 209.277)",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5
}))));
export default __webpack_public_path__ + "static/media/house.219fcb1d.svg";
export { SvgComponent as ReactComponent };